import { render, staticRenderFns } from "./CommentsDialog.vue?vue&type=template&id=0e1c4bd9&scoped=true"
import script from "./CommentsDialog.vue?vue&type=script&lang=js"
export * from "./CommentsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentsDialog.vue?vue&type=style&index=0&id=0e1c4bd9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c4bd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1c4bd9')) {
      api.createRecord('0e1c4bd9', component.options)
    } else {
      api.reload('0e1c4bd9', component.options)
    }
    module.hot.accept("./CommentsDialog.vue?vue&type=template&id=0e1c4bd9&scoped=true", function () {
      api.rerender('0e1c4bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/SAS/Components/CommentsDialog.vue"
export default component.exports